import { render } from "./MediaflowShortcuts.vue?vue&type=template&id=e23c6730"
import script from "./MediaflowShortcuts.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowShortcuts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowShortcuts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e23c6730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e23c6730', __exports__)) {
    api.reload('e23c6730', __exports__)
  }
  
  module.hot.accept("./MediaflowShortcuts.vue?vue&type=template&id=e23c6730", () => {
    api.rerender('e23c6730', render)
  })

}


export default __exports__